export default {
    created() {
        this.$validator.extend('user', {
            validate: (value, options) => {
                let field = options[0];
                let user = options[1];
                return axios.post(
                    '/api/users/validate/' + field,
                    user
                ).then(response => {
                    return { valid: true }
                }).catch(error => {

                    let message = _.get(error.response, ['data', 'errors', field, 0]);
                    if (message) {
                        return {
                            valid: false,
                            data: {
                                message: message
                            }
                        }
                    } else {
                        return { valid: true }
                    }
                });
            },
            getMessage: (field, params, data) => {
                return data.message;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/views/users/mixins/validates-users.js